import { render } from "./LongResponsePreview.vue?vue&type=template&id=6b4cb8e4&scoped=true"
import script from "./LongResponsePreview.vue?vue&type=script&lang=js"
export * from "./LongResponsePreview.vue?vue&type=script&lang=js"

import "./LongResponsePreview.vue?vue&type=style&index=0&id=6b4cb8e4&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b4cb8e4"]])

export default __exports__